import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'interbat',
    pathMatch: 'full'
  },
  {
    path: 'interbat',
    loadChildren: () => import('./interbat/interbat.module').then(m => m.InterbatModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}